import { DetailsHeader, Segments } from "components";
import { Navigate, Route, Routes } from "react-router";
import PeopleActivityReport from "./Activity/PeopleActivityReport";
import { UsersReport } from "./Users/PeopleUsersReport";
import PeopleOverviewReport from "./Overview/PeopleOverviewReport";
import { useCallback, useRef } from "react";
import AcquisitionReport from "./Acquisition/PeopleAcquisitionReport";
import { useFeatureFlag } from "hooks/useFeatureFlag";
import { FeatureFlags } from "featureFlags";
import { ReportUnavailable } from "components/reportUnavailable/ReportUnavailable";

const pages = [
  { to: "overview", label: "Overview" },
  { to: "activity", label: "Activity" },
  { to: "acquisition", label: "Acquisition" },
  { to: "users", label: "Users" },
];

export const ReportingPeople = () => {
  const isPeopleReportingEnabled = !!useFeatureFlag(FeatureFlags.PeopleReports);
  const rootRef = useRef<HTMLDivElement>(null);
  const scrollToTop = useCallback(() => {
    rootRef.current?.scrollTo({ top: 0, left: 0 });
  }, []);

  if (!isPeopleReportingEnabled) {
    return <ReportUnavailable />;
  }

  return (
    <div className="nested-content people-reporting-root" ref={rootRef}>
      <DetailsHeader title="People" showReportLastUpdated />
      <Segments to="/reporting/people">
        {pages.map((page) => (
          <Segments.Segment key={page.to} {...page} />
        ))}
      </Segments>
      <div className="reportBody">
        <Routes>
          <Route path="overview" element={<PeopleOverviewReport scrollToTop={scrollToTop} />} />
          <Route path="activity" element={<PeopleActivityReport />} />
          <Route path="acquisition" element={<AcquisitionReport />} />
          <Route path="users" element={<UsersReport />} />
          <Route path="*" element={<Navigate to="overview" replace />} />
        </Routes>
      </div>
    </div>
  );
};
